goog.provide("shadow.js.shim.module$date_fns$locale$de$default");
shadow.js.shim.module$date_fns$locale$de$default = esm_import$date_fns$locale$de.default;
